export enum ScheduleFrequency {
  Now = -1,
  OneTime = 0,
  Daily = 1,
  Weekly = 2,
  Monthly = 3
}